import { render, staticRenderFns } from "./awards.vue?vue&type=template&id=56aa3888&"
import script from "./awards.vue?vue&type=script&lang=js&"
export * from "./awards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports